export const QUOTA_LIMIT_ERROR_TYPE = {
  TRIAL_EMAIL_QUOTA_EXCEEDED: 'TRIAL_EMAIL_QUOTA_EXCEEDED',
};
